import recipients from "../../api/recipients";
import { perPageCount } from "@/common/constants";
import { dummyRows, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      perPage: perPageCount,
      listtype: "",
      criteria: "lstname",
      searchKey: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    total: 0,
    busyLoaderStatus: true,
    addedit: 3,
    import_progress: [],
    showFilter: false,
    listCurStatus: 3,
    listlogState: false,
    listLogData: [],
    listLogCount: 0,
    logOffset: 0,
    emailDeleted: 0,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      if (item._showDetails) {
        return item;
      }
      var openRate = item.openRatePercentage;
      var uploadStatus = "Uploading";
      if (parseInt(item.status) === 5 && parseInt(item.exceed) === 1) {
        uploadStatus = "Contact limit reached";
      }

      return {
        id: item.id,
        rec_id: item.listID,
        listname: {
          title: item.listname,
          status: item.status,
          tooltipTitle:
            parseInt(item.status) === 5 ? "importing" : "count updating",
        },
        rec_status: {
          loading: !!(item.listStatus !== ""),
          tooltipTitle:
            parseInt(item.status) === 5 ? uploadStatus : item.listStatus,
          percentage: item.status === 6 ? item.listPercentage : "nodata",
        },
        modifiedDate: item.mDate,
        listStatus: item.status,
        listProcess: item.listStatus,
        totalCount: item.totalCount,
        listcategory: parseInt(item.categoryId),
        contact_active: item.active,
        openRate: {
          first: openRate + "%",
          second: convertCount(item.openRate),
        },
        cam_actions: { Export: parseInt(item.categoryId) === 2 },
        verifyList: item.verifyList,
      };
    });
  },
  getListLogs: (state) => {
    if (!state.listlogState) {
      return dummyRows();
    }

    var array = [];

    if (state.listLogData && state.listLogData.logs) {
      var i = state.logOffset;
      state.listLogData.logs.forEach(function (entry) {
        i = i + 1;
        array.push({
          sl_no: i,
          list_name: entry.listname,
          list_logs: entry.logs.join("<br>"),
          process_log: entry.importProcessLog.length
            ? entry.importProcessLog.join("<br>")
            : "",
          created_date: entry.createdDate,
        });
      });
    }

    return array;
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    commit("setEmailDeleted", 0);
    commit("setImportProgress", { items: [] });
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.perPage !== params.perPage ||
      filter.searchKey !== params.searchKey ||
      filter.listtype !== params.listtype ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order ||
      filter.criteria !== params.criteria
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        recipients.fetchItems(params, (data) => {
          commit("setImportProgress", { items: data.import_process });
          commit("setEmailDeleted", data.deleted_email);
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setTotal", data.total_listfoud);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },
  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  getListLogSdata({ commit }, params) {
    recipients.listlogs(params, (data) => {
      commit("setLogCount", data.counts);
      commit("setLogOffset", data.offset);
      commit("setListLogData", { items: data.data });
    });
  },

  getSigleListDetails(_, params) {
    return recipients.getSigleListDetails(params);
  },

  contactExport(_, params) {
    return recipients.contactExport(params);
  },

  deleteList({ dispatch }, { id }) {
    return recipients.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },
  refreshList({ commit, state, dispatch }, { id, index }) {
    commit("setBusyLoaderStatus", false);
    var items = state.items;
    items[index] = { _showDetails: true };
    commit("setItems", { items: [...items] });
    return recipients.refresh(id).then(function () {
      dispatch("refreshItems");
    });
  },
  rename({ dispatch }, params) {
    return recipients.rename(params).then(function () {
      dispatch("refreshItems");
    });
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },
  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },
  setImportProgress(state, { items }) {
    state.import_progress = items;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  setTotal(state, total) {
    state.total = total;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  SetaddEditItemLoaded(state, loaded) {
    state.addedit = loaded;
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
  setListStatus(state, status) {
    state.listCurStatus = status;
  },
  setLogCount(state, items) {
    state.listLogCount = items;
  },
  setListLogData(state, { items }) {
    state.listLogData = items;
    state.listlogState = true;
  },
  setLogOffset(state, offset) {
    state.logOffset = offset;
  },
  setEmailDeleted(state, value) {
    state.emailDeleted = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
